import { Box, SxProps, Theme } from "@mui/material";

import { theme } from "@/src/theme/theme";

interface AlmaLogoProps {
  size?: number | string;
  color?: string;
  sx?: SxProps<Theme>;
}

const AlmaLogo = (props: AlmaLogoProps) => {
  const { size = "100%", color = theme.palette.text.primary, sx } = props;

  return (
    <Box
      sx={[
        {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          width: size,
          height: size,
          svg: { maxWidth: "100%", maxHeight: "100%", fill: color }
        },
        ...(Array.isArray(sx) ? sx : [sx])
      ]}
    >
      <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g transform="matrix(.084353 0 0 .083851 3.0657 2.4925)">
          <g transform="translate(2.2547e-6 5.034)">
            <path
              transform="translate(-2.2547e-6 -5.034)"
              d="m0.5625 5.5938-0.03125 59.25 176.69-0.5 0.4375 29.844-176.78-0.34375-0.34375 147.69 235.91 0.0312-0.78125-235.5zm177.03 146.81-0.0312 30.188-117.78-0.0937-0.1875-29.719 118-0.375z"
            />
          </g>
          <g transform="translate(265.8 270.41)">
            <path
              transform="translate(-265.8 -270.41)"
              d="m266.34 270.97v59.25l176.66-0.5 0.4375 29.844-176.75-0.34375-0.375 147.69 235.94 0.0312-0.78125-235.5-235.12-0.46875zm177.06 146.81-0.0625 30.188-117.75-0.0937-0.1875-29.688 118-0.40625z"
            />
          </g>
          <path d="m324.55 5.7811 0.40097 176.78 175.7-5e-3 -0.11402 58.912-235.07 0.0699-0.0974-235.84z" />
          <path d="m236.24 270.37-0.39612 235.84-58.273 0.35785-0.96511-177.79h-28.223l-0.7449 177.79h-59.115l0.29022-177.79h-28.768l-0.3959 177.79h-59.248l-0.23119-236.05z" />
        </g>
      </svg>
    </Box>
  );
};

export default AlmaLogo;
